import BatchAssign from './BatchAssign';

export default BatchAssign;
